import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import { useLegalClientRepresentativeSaveCompanyAddressesMutation } from 'api/generated/graphql';
import { useError } from 'api/helpers';
import { LegalClientSaveRegistrationAddressesParam } from 'api/types/params';

import { parseLegalClientRepresentative } from '../helpers';

export const useLegalClientRepresentativeSaveCompanyAddresses = () => {
  const [handle, { data, loading, error: apolloError }] =
    useLegalClientRepresentativeSaveCompanyAddressesMutation();

  const error = useError(apolloError);

  return {
    data: data?.legalClientRepresentativeSaveCompanyAddresses
      ? parseLegalClientRepresentative(
          data.legalClientRepresentativeSaveCompanyAddresses
        )
      : undefined,
    loading,
    error,
    saveAddresses: useCallback(
      async (id: string, params: LegalClientSaveRegistrationAddressesParam) => {
        const res = await handle({
          variables: {
            id,
            input: params,
          },
        });
        return res?.data?.legalClientRepresentativeSaveCompanyAddresses
          ? parseLegalClientRepresentative(
              res.data.legalClientRepresentativeSaveCompanyAddresses
            )
          : undefined;
      },
      [handle]
    ),
  };
};
